import { race, select, take } from 'redux-saga/effects';

import { billingDataFailure, getBillingDataSuccess } from './billingData.module';
import { BillingDataSelectors } from './billingData.selectors';

export function* handleBillingDataSuccess() {
    const { isLoaded, isLoading } = yield select(BillingDataSelectors.getBillingDataLoadingState);

    if (isLoaded && !isLoading) {
        return true;
    }

    const { success } = yield race({
        success: take(getBillingDataSuccess),
        fail: take(billingDataFailure),
    });

    return !!success;
}
